/** Stable content adapter; authoring never rewrites this module. */
import { bindContent, contentCatalog } from "../content/catalog"
export let ItemTypesWeight: Partial<Record<string, Partial<Record<string, number>>>> = contentCatalog.items.weight

// Rebuild the complete table group during preparation; activation only assigns bindings.
bindContent(catalog => ({
    ItemTypesWeight: catalog.items.weight,
}), next => {
    ItemTypesWeight = next.ItemTypesWeight
})
